/**
 * A branch's Compare pane as an open item (RFC 0313 3k):
 * `branch:<projectId>:<name>`, self-describing like a web page.
 */

const PREFIX = 'branch:'

export const isBranchId = (id: string): boolean => id.startsWith(PREFIX)

export const branchPaneId = (projectId: string, name: string): string =>
  `${PREFIX}${projectId}:${encodeURIComponent(name)}`

export function branchPaneOf(
  id: string,
): { projectId: string; name: string } | null {
  if (!isBranchId(id)) return null
  const rest = id.slice(PREFIX.length)
  const at = rest.indexOf(':')
  if (at <= 0) return null
  return {
    projectId: rest.slice(0, at),
    name: decodeURIComponent(rest.slice(at + 1)),
  }
}

export function branchSubject(projectId: string, name: string) {
  return {
    id: branchPaneId(projectId, name),
    title: `${name} into main`,
    path: `${name} into main`,
    mime: 'application/x-mod-branch',
  }
}
